export enum AccommodationProviderEnum {
  WEBHOTELIER = 'WEBHOTELIER',
  HOTELBEDS = 'HOTELBEDS',
  PULPO = 'PULPO',
}
